PJQ.collections.primeContracts = {};

PJQ.models.primeContracts = {};

PJQ.views.primeContracts = {};

PJQ.modules.primeContracts = {
    routes: [
        {
            route: 'projects/:projectId/contracts',
            name: 'primecontracts',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts");
            }
        },
        {
            route: 'projects/:projectId/contracts/:primeContractId',
            name: 'primecontract',
            callback: function (projectId, primeContractId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    primeContractId: parseInt(primeContractId)
                });
            }
        },
        {
            route: 'projects/:projectId/contracts/changeorders',
            name: 'primecontractchangeorders',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    view: 'changeorders'
                });
            }
        },
        {
            route: 'projects/:projectId/contracts/changerequests',
            name: 'primecontractchangerequests',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    view: 'changerequests'
                });
            }
        },
        {
            route: 'projects/:projectId/changerequests/:changeRequestId',
            name: 'primecontractchangerequest',
            callback: function (projectId, changeRequestId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    changeRequestId: parseInt(changeRequestId)
                });
            }
        },
        {
            route: 'projects/:projectId/contractchangeorders',
            name: 'primecontractchangeorders',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    view: 'changeorders'
                });
            }
        },
        {
            route: 'projects/:projectId/contractchangeorders/:changeOrderId',
            name: 'primecontractchangeorder',
            callback: function (projectId, changeOrderId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    changeOrderId: parseInt(changeOrderId)
                });
            }
        },
        {
            route: 'projects/:projectId/contracts/invoices',
            name: 'receivableinvoices',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    view: 'invoices'
                });
            }
        },
        {
            route: 'projects/:projectId/receivableinvoices',
            name: 'receivableinvoices',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    view: 'invoices'
                });
            }
        },
        {
            route: 'projects/:projectId/receivableinvoices/:invoiceId',
            name: 'receivableinvoice',
            callback: function (projectId, invoiceId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "primecontracts", {
                    invoiceId: parseInt(invoiceId)
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.primeContracts.routes);
